export default "__VITE_ASSET__CGPBDkka__"